import React from 'react';

import { useAccountState, useAccountActions } from './AccountContext';
import { updateCurrentAccountPassword } from './restApi';
import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

const PasswordUpdateForm = () => {
  const state = useAccountState();
  const { onResponse, onError, updatePasswordFormCurrentPassword, updatePasswordFormNewPassword, updatePasswordFormConfirmPassword, closePasswordUpdateModal } = useAccountActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleSubmit = () => {
    updateCurrentAccountPassword({
      onResponse,
      onError,
      body: {
        currentPassword: state?.passwordUpdateForm?.currentPassword || '',
        newPassword: state?.passwordUpdateForm?.newPassword || '',
        newPasswordConfirmation: state?.passwordUpdateForm?.confirmPassword || '',
        authenticityToken,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Field label="Current Password" id="current_password">
        <Input
          type="password"
          name="session[current_password]"
          value={state?.passwordUpdateForm?.currentPassword || ''}
          onChange={(e) => updatePasswordFormCurrentPassword(e.target.value)}
        />
      </Field>

      <Field label="New Password" id="new_password">
        <Input
          type="password"
          name="session[new_password]"
          value={state?.passwordUpdateForm?.newPassword || ''}
          onChange={(e) => updatePasswordFormNewPassword(e.target.value)}
        />
      </Field>

      <Field label="New Password Confirmation" id="new_password_confirmation">
        <Input
          type="password"
          name="session[new_password_confirmation]"
          value={state?.passwordUpdateForm?.confirmPassword || ''}
          onChange={(e) => updatePasswordFormConfirmPassword(e.target.value)}
        />
      </Field>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => closePasswordUpdateModal()}
          >
            Cancel
          </Button>
          <Button type="submit">
            Update Password
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default PasswordUpdateForm;
